module.exports = __webpack_public_path__ + "static/two-prime-movers-of-globalization-825fd3f71afe80395f9ff5f6a52948c2.jpg";